var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAlarmYellow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.33333 3.16699L2 4.50033",
    stroke: "#FD9644",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6667 3.16699L14 4.50033",
    stroke: "#FD9644",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.99935 13.8337C10.9449 13.8337 13.3327 11.4458 13.3327 8.50033C13.3327 5.55481 10.9449 3.16699 7.99935 3.16699C5.05383 3.16699 2.66602 5.55481 2.66602 8.50033C2.66602 11.4458 5.05383 13.8337 7.99935 13.8337ZM10.1136 7.45835C10.4586 7.02709 10.3886 6.3978 9.95738 6.05279C9.52612 5.70778 8.89682 5.7777 8.55181 6.20896L7.79121 7.15972L6.55405 6.33494C6.09452 6.02859 5.47365 6.15276 5.1673 6.61229C4.86095 7.07182 4.98512 7.69269 5.44465 7.99904L7.25394 9.20524C7.79343 9.5649 8.51836 9.45234 8.9234 8.94604L10.1136 7.45835Z",
    fill: "#FD9644"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarmYellow);
export default __webpack_public_path__ + "static/media/alarm-yellow.77a86bc3e2bd1b30dcfa8950fe877be0.svg";
export { ForwardRef as ReactComponent };